import React, { FC } from 'react';
import { Button, Icon, Modal } from 'src/components';
import { defineMessages, useIntl } from 'react-intl';
import { Color } from 'src/utils/theme';
import { IconName } from 'src/components/Icon';
import * as S from './styles';

const msgs = defineMessages({
  welcome: {
    id: 'onboarding_welcomeDisplayingProgress_title',
  },
  description: {
    id: 'onboarding_welcomeDisplayingProgress_description',
  },
  learnTitle: {
    id: 'homeScreen_learnWords',
  },
  learnDescription: {
    id: 'onboarding_welcomeDisplayingProgress_learnWords_description',
  },
  immerseTitle: {
    id: 'homeScreen_hearMyWords',
  },
  immerseDescription: {
    id: 'homeScreen_miniPlayer_hearMyWords_description',
  },
  communicateTitle: {
    id: 'homeScreen_useMyWords',
  },
  communicateDescription: {
    id: 'homeScreen_miniPlayer_useMyWords_description',
  },
  ok: {
    id: 'onboarding_coreLoopUsersToProgress_proficiencyLevel_CTA',
  },
});

const Card = ({
  backgroundColor,
  iconName,
  iconColor,
  title,
  description,
}: {
  backgroundColor: Color;
  iconName: IconName;
  iconColor: Color;
  title: string;
  description: string;
}) => (
  <S.Card $backgroundColor={backgroundColor}>
    <S.IconColumn $iconColor={iconColor}>
      <Icon name={iconName} />
    </S.IconColumn>
    <S.TextColumn>
      <S.CardTitle>{title}</S.CardTitle>
      <S.CardDescription>{description}</S.CardDescription>
    </S.TextColumn>
  </S.Card>
);

export const WelcomePopup: FC<{
  isOpen: boolean;
  onClose: () => void;
  progressIndicator?: string;
}> = ({ isOpen, onClose, progressIndicator }) => {
  const intl = useIntl();

  return (
    <Modal darkCloseIcon isOpen={isOpen} handleClose={onClose}>
      <S.ModalContent>
        <S.ModalHeader>{intl.formatMessage(msgs.welcome)}</S.ModalHeader>
        <S.Description>{intl.formatMessage(msgs.description)}</S.Description>
        <S.CardsWrapper>
          <Card
            title={intl.formatMessage(msgs.learnTitle)}
            description={intl.formatMessage(msgs.learnDescription)}
            iconName="learnFilled"
            backgroundColor="success98"
            iconColor="success40"
          />
          <Card
            title={intl.formatMessage(msgs.immerseTitle)}
            description={intl.formatMessage(msgs.immerseDescription)}
            iconName="videoLibraryFilled"
            backgroundColor="error98"
            iconColor="error60"
          />
          <Card
            title={intl.formatMessage(msgs.communicateTitle)}
            description={intl.formatMessage(msgs.communicateDescription)}
            iconName="communicateFilled"
            backgroundColor="information98"
            iconColor="information50"
          />
        </S.CardsWrapper>
        <S.ActionButton>
          <Button buttonSize="medium" buttonType="primary" wide onClick={onClose}>
            {intl.formatMessage(msgs.ok)}
          </Button>
        </S.ActionButton>
        {progressIndicator && <S.ProgressIndicator>{progressIndicator}</S.ProgressIndicator>}
      </S.ModalContent>
    </Modal>
  );
};
